import { takeLatest } from 'redux-saga/effects';
import { GlobalActions, ZAEHLSTUECKEREQUEST } from '@ps20-frontend/shop-integration-redux';
import { addTaasLoadingActions } from './addTaasLoadingActions.util';
import { addTaasUpdateAppErrorHandling } from './addTaasUpdateAppErrorHandling';

export const updateAppActionsGenerator = () => {
  return [new GlobalActions().updateZaehlstuecke()];
};

export const updateAppSuccessActions = () => [GlobalActions.ZAEHLSTUECKE_RECEIVED];

export const updateAppFailActions = () => [ZAEHLSTUECKEREQUEST.ZAEHLSTUECKE_REQUEST_FAILED];

export const updateAppAndTarifiere = addTaasLoadingActions(
  addTaasUpdateAppErrorHandling(
    updateAppActionsGenerator,
    updateAppSuccessActions,
    updateAppFailActions,
  ),
);

export function* watchUnfallZaehlstueckeChanged() {
  yield takeLatest(GlobalActions.UNFALL_ZAEHLSTUECKE_CHANGED, updateAppAndTarifiere);
}
